import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import big_banner from "../Assests/Newbanner.png";
import "./Banner.css";

function Banner() {
  const { t } = useTranslation();
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setAnimated(true);
  }, []);

  return (
    <>
      <div className="banner-container">
        <div 
          className="banner-background"
          style={{ backgroundImage: `url(${big_banner})` }}
        >
          <div className="banner-overlay">
            <div className="container">
              <div className="banner-content">
                <h1 className={`banner-title ${animated ? 'animate-slide-up' : ''}`}>
                  {t("heading_new") || "समाज समृद्ध-देश समृद्ध"}
                </h1>
                <p className={`banner-subtitle ${animated ? 'animate-slide-up delay-1' : ''}`}>
                  {t("heading_new2") || "स्वर्गीय सुरेश सिंह फाउंडेशन® ट्रस्ट का उद्देश्य व्यक्तियों के बीच जागरूकता लाना एवं प्रचलित सामाजिक मुद्दों के समाधान हेतु उन्हें एक साथ खड़ा करना है।"}
                </p>
                <button 
                  className={`banner-cta ${animated ? 'animate-fade-in delay-2' : ''}`}
                  onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
                >
                  Know More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;